export const AdminTopPage = () => {
  return (
    <>
      <div>ログイン後のTOPページ</div>
    </>
  );
};
